export const buildAuthRedirectPath = (path: string | null | undefined, hasAuthFlag: boolean): string => {
  if (hasAuthFlag) return "/";
  if (!path) return "/";

  if (path.includes("?")) {
    return `${path}&__auth=1`;
  }

  return `${path}?__auth=1`;
};
